import { Tooltip } from 'antd'
import React, { ChangeEvent, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { triggerNotification, useGetApiRequests } from '../../../../common/CommonExport';
import ModalLoader from '../../../../components/Loader/ModalLoader';
import DocumentPDFView from '../../../employee/employee-details/employee-profile/layout/documents/documentPDFView';
import DeleteConfirmationModal from '../../../Organization/DeleteConfirmationModal';
import noRecordFound from "../../../../assets/images/empty-folder.png"
import { useIsMobile } from '../../../../hooks/commonHooks';

export default function UserDocument() {
  const id = useSelector((state: any) => state?.userId?.id);

  const orgId = useSelector((state: any) => state?.organisationId?.id);
  const reduxToken = useSelector((state: any) => state?.authToken?.token);
  const documentReload = useSelector((state: any) => state?.profileReload?.documentReload);
  const employeeDocumentList = useGetApiRequests('employeeDocumentStatus', 'GET');
  const employeeDocumentDelete = useGetApiRequests('documentDownload', 'DELETE');
  const employeeDocumentUpload = useGetApiRequests('documentUpload', 'POST');
  const [documentDetails, setDocumentDetails] = useState<any>()
  const [documentTypeDetails, setDocumentTypeDetails] = useState<any>()
  const [documentView, setDocumentView] = useState<any>(false)
  const [currentPdfDetails, setCurrentPdfDetails] = useState<any>({})
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [deleteMessage, setDeleteMessage] = useState('');
  const [loader, setLoader] = useState<any>(true)
  const baseUrl = process.env.REACT_APP_GOOGLR_DOCUMENT_VIEW;
  const isMobile = useIsMobile();
  const getDocumentApiData = async () => {
    setLoader(true)
    const pathParam = { id, end: 'document/list' }
    const pathParamsList = { id, end: 'documentDetail' }
    try {
      const [documentDetailsData, documentTypeDetailsData]: any = await Promise.all([
        employeeDocumentList('', { organisationId: orgId }, pathParam),
        employeeDocumentList('', { sessionToken: reduxToken }, pathParamsList)
      ]);
      setDocumentDetails(documentDetailsData?.data?.data)
      setDocumentTypeDetails(documentTypeDetailsData?.data?.data)
      setTimeout(() => {
        setLoader(false)
      }, 1000)
    } catch (error: any) {
      setTimeout(() => {
        setLoader(false)
      }, 1000)
      triggerNotification('error', '', error?.data?.message, 'topRight');
    }
  };
  useEffect(() => {
    getDocumentApiData()
  }, [documentReload])

  const finalSubmit = (formData: any, documentTypeId: any) => {
    const documentDto = { documentDto: { documentTypeId: documentTypeId, employeeId: parseInt(id), organisationId: orgId } };
    const headers = { 'Content-Type': 'multipart/form-data' };
    employeeDocumentUpload(formData, documentDto, {}, headers)
      .then((res: any) => {
        triggerNotification('success', '', res?.data?.message, 'topRight');
        getDocumentApiData()
      })
      .catch((err: any) => {
        console.error(err);
      });
  }
  const getFileExtension = (filePath: string): string | null => {
    const match = filePath.match(/\.([^.]+)$/);
    return match ? match[1].toLowerCase() : null;
  };

  const handleViewDocument = (details: any) => {
    setLoader(true)
    const extension = getFileExtension(details?.documentPath)
    setCurrentPdfDetails(details)

    if (extension === 'pdf' && baseUrl && details?.documentPath) {


      setTimeout(() => {
        setLoader(false)

        window.open(`${baseUrl}${details?.documentPath}`, '_blank')


      }, 2000)
    } else {
      setTimeout(() => {
        setLoader(false)
      }, 1000)

      setDocumentView(true)
    }
  }

  const handleDeleteSelected = () => {
    const pathParams = {
      id: currentPdfDetails?.documentDetailId,
    };
    employeeDocumentDelete('', {}, pathParams)
      .then((res: any) => {
        triggerNotification('success', '', res?.data?.message, 'topRight');
        getDocumentApiData()
      })
      .catch((err: any) => {
        console.error(err);
      });
  };
  const handleCloseDelete = () => setDeletePopUp(false);

  const handlehrImage = (event: ChangeEvent<HTMLInputElement>, item: any) => {
    const file: any = event.target.files?.[0];
    const formData = new FormData();
    formData.append('files', file);
    finalSubmit(formData, item?.documentTypeId)
  };
  
  return (
    <div className='documents md:flex justify-between flex-col'>
      {loader && <ModalLoader />}
      <div className='documents-container'>
        {documentDetails?.length > 0 ? (
          <>
            {documentDetails?.map((item: any, index: any) => (
              <div key={item?.documentTypeId} className="documents-item document mb-7">
                <div className="document-title mb-4">
                  <h3 className='font-rubik text-base'>{`${index + 1}. ${item?.folderName}`}</h3>
                </div>
                {documentTypeDetails?.map((innerItem: any, innerIndex: any) => (
                  <>
                    {innerItem?.document?.documentId === item?.documentId && (
                      <div>
                        <div key={innerItem?.document?.documentTypeId} className="document-view flex justify-between items-center md:max-w-xl w-full" >
                          <p className="document-fileName font-rubik">
                            {innerItem?.name}
                          </p>
                          <div className="document-action flex items-center">
                            {!isMobile ? <Tooltip placement="top" title={'View'}>
                              <div onClick={() => handleViewDocument(innerItem)} className="document-action__icon">
                                <span className="material-symbols-outlined">visibility</span>
                              </div>
                            </Tooltip> : <div onClick={() => handleViewDocument(innerItem)} className="document-action__icon">
                              <span className="material-symbols-outlined">visibility</span>
                            </div>}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ))}

              </div>

            ))}
          </>
        ) : <div className="no-record flex justify-center items-center  no-record-documents absolute">
          <p className='flex justify-center items-center text-xl'> <img src={noRecordFound} alt="" />
          </p>
        </div>
        }

        {documentView && <DocumentPDFView open={documentView} setDocumentView={setDocumentView} currentPdfDetails={currentPdfDetails} certificate={false} mainPage={false} />}
        {deletePopUp && <DeleteConfirmationModal open={deletePopUp} handleDeleteSelected={handleDeleteSelected} handleCloseDelete={handleCloseDelete} type='Delete' deleteMessage={deleteMessage} />}
      </div>
    </div>
  )
}
